/*
 * wallace-size-guide.js
 * ------------------------------------------------------------
 * cm / in toggle for the size guide panel (snippets/wallace-size-drawer.liquid).
 * Every [data-raw] cell holds the metaobject value as entered (inches, e.g.
 * 17.75", 33" - 39", 16 1/2"; or centimetres when data-raw-unit="cm", as in the
 * footwear chart's length columns). Numbers are parsed out of it and
 * re-displayed in the chosen unit. Cells with no number, or more than two, keep
 * their raw text. Cells without data-raw (size labels) are never touched.
 * Choice is remembered in localStorage under "wallace-size-unit".
 * ------------------------------------------------------------
 */
(function () {
  var STORAGE_KEY = 'wallace-size-unit';
  var NUMBER_RE = /(\d+)\s+(\d+)\s*\/\s*(\d+)|(\d+)\s*\/\s*(\d+)|\d*\.?\d+/g;

  function slice(list) {
    return Array.prototype.slice.call(list);
  }

  function readStored() {
    try {
      var value = window.localStorage.getItem(STORAGE_KEY);
      return value === 'cm' || value === 'in' ? value : null;
    } catch (e) {
      return null;
    }
  }

  function writeStored(unit) {
    try {
      window.localStorage.setItem(STORAGE_KEY, unit);
    } catch (e) {
      /* storage unavailable: choice just isn't remembered */
    }
  }

  function parseNumbers(raw) {
    var numbers = [];
    var match;
    NUMBER_RE.lastIndex = 0;
    while ((match = NUMBER_RE.exec(raw)) !== null) {
      if (match[1] !== undefined) {
        numbers.push(parseInt(match[1], 10) + parseInt(match[2], 10) / parseInt(match[3], 10));
      } else if (match[4] !== undefined) {
        numbers.push(parseInt(match[4], 10) / parseInt(match[5], 10));
      } else {
        numbers.push(parseFloat(match[0]));
      }
    }
    return numbers;
  }

  function formatCm(inches) {
    var cm = Math.round(inches * 2.54 * 2) / 2;
    return cm % 1 === 0 ? String(cm) : cm.toFixed(1);
  }

  function formatIn(inches) {
    return String(+inches.toFixed(2));
  }

  function convert(raw, unit, sourceUnit) {
    var numbers = parseNumbers(raw);
    if (numbers.length === 0 || numbers.length > 2) return raw;
    if (sourceUnit === 'cm') {
      numbers = numbers.map(function (n) {
        return n / 2.54;
      });
    }
    var format = unit === 'cm' ? formatCm : formatIn;
    var first = format(numbers[0]);
    var text = first;
    if (numbers.length === 2) {
      var second = format(numbers[1]);
      text = first === second ? first : first + '\u2013' + second;
    }
    return text + ' ' + unit;
  }

  function apply(root, unit) {
    slice(root.querySelectorAll('[data-raw]')).forEach(function (cell) {
      var raw = cell.getAttribute('data-raw') || '';
      var sourceUnit = cell.getAttribute('data-raw-unit') === 'cm' ? 'cm' : 'in';
      cell.textContent = convert(raw, unit, sourceUnit);
    });
    slice(root.querySelectorAll('[data-size-unit]')).forEach(function (button) {
      button.setAttribute('aria-pressed', button.getAttribute('data-size-unit') === unit ? 'true' : 'false');
    });
  }

  function initRoot(root) {
    if (root.hasAttribute('data-size-guide-ready')) return;
    root.setAttribute('data-size-guide-ready', '');

    var unit = readStored() || (root.getAttribute('data-default-unit') === 'in' ? 'in' : 'cm');
    apply(root, unit);

    root.addEventListener('click', function (event) {
      var button = event.target && event.target.closest ? event.target.closest('[data-size-unit]') : null;
      if (!button) return;
      unit = button.getAttribute('data-size-unit') === 'in' ? 'in' : 'cm';
      writeStored(unit);
      apply(root, unit);
    });
  }

  function init() {
    slice(document.querySelectorAll('[data-wallace-size-guide]')).forEach(initRoot);
  }

  // The generic drawer moves the panel to <body> on its own init, so run on
  // DOMContentLoaded (after deferred scripts) and again when a panel opens.
  document.addEventListener('wallace-drawer:open', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
